
import React, { useState } from 'react';

const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        backdropFilter: 'blur(4px)'
    },
    modalContent: {
        background: 'white',
        padding: '32px',
        borderRadius: '16px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
        border: '1px solid #e2e8f0'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#0f172a',
        margin: 0
    },
    formGroup: { marginBottom: '20px' },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#374151',
        fontSize: '14px'
    },
    input: {
        width: '100%',
        padding: '12px 16px',
        fontSize: '14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        boxSizing: 'border-box',
        outline: 'none',
        transition: 'border-color 0.2s'
    },
    select: {
        width: '100%',
        padding: '12px 16px',
        fontSize: '14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        outline: 'none',
        transition: 'border-color 0.2s'
    },
    checkboxLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        color: '#374151',
        userSelect: 'none'
    },
    checkbox: {
        width: '18px',
        height: '18px',
        cursor: 'pointer'
    },
    modalActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        marginTop: '30px'
    },
    button: {
        padding: '12px 24px',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        transition: 'all 0.2s'
    },
    cancelButton: {
        background: '#f1f5f9',
        color: '#475569'
    },
    printButton: {
        background: 'linear-gradient(135deg, #06C167, #8b5cf6)',
        color: 'white',
        boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)'
    }
};

const BarcodePrintModal = ({ product, products: initialProducts, onClose, canViewPrices }) => {
    // If 'product' (singular) is passed, wrap it in an array for consistent handling
    const initialList = initialProducts || (product ? [product] : []);

    const [settings, setSettings] = useState({
        count: 1, // Global count (used only if singular or as default)
        showPrice: canViewPrices,
        size: 'medium'
    });

    // Track quantities for each product in the list
    const [productQuantities, setProductQuantities] = useState(
        initialList.reduce((acc, p) => ({ ...acc, [p.id]: 1 }), {})
    );

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');

        if (!printWindow) {
            alert("Barkod önizleme penceresi açılamadı. Lütfen tarayıcınızın pop-up engelleyicisini kapatın ve tekrar deneyin.");
            return;
        }

        const sizeConfig = {
            small: { width: '150px', barcodeSize: '32px', fontSize: '12px', padding: '10px' },
            medium: { width: '220px', barcodeSize: '48px', fontSize: '14px', padding: '15px 20px' },
            large: { width: '300px', barcodeSize: '64px', fontSize: '18px', padding: '20px 25px' },
            thermal_55x40: { width: '55mm', height: '40mm', barcodeSize: '40px', fontSize: '12px', padding: '3mm' }
        };

        const config = sizeConfig[settings.size];
        let labelsHtml = '';

        initialList.forEach(p => {
            const qty = Math.max(0, parseInt(productQuantities[p.id]) || 0);

            for (let i = 0; i < qty; i++) {
                labelsHtml += `
                    <div style="
                        border: ${settings.size === 'thermal_55x40' ? 'none' : '1px solid #ddd'};
                        padding: ${config.padding};
                        margin: ${settings.size === 'thermal_55x40' ? '0' : '10px'};
                        display: ${settings.size === 'thermal_55x40' ? 'flex' : 'inline-block'};
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        page-break-after: always;
                        width: ${config.width};
                        height: ${config.height || 'auto'};
                        box-sizing: border-box;
                        overflow: hidden;
                    ">
                        <div style="font-size: ${config.fontSize}; font-weight: bold; margin-bottom: 4px; color: #333; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                            ${p.name}
                        </div>
                        <div style="
                            font-family: 'Libre Barcode 128', 'Courier New', monospace;
                            font-size: ${config.barcodeSize};
                            line-height: 1;
                            margin: 2px 0;
                        ">
                            ${p.barcode}
                        </div>
                        <div style="
                            font-family: 'Courier New', monospace;
                            font-size: ${parseInt(config.fontSize)}px;
                            font-weight: bold;
                            letter-spacing: 1px;
                            color: #333;
                        ">
                            ${p.barcode}
                        </div>
                        ${settings.showPrice && p.salePrice ? `
                            <div style="font-size: ${parseInt(config.fontSize) + 2}px; font-weight: bold; margin-top: 4px; color: #000;">
                                ${p.salePrice.toLocaleString('tr-TR')} ₺
                            </div>
                        ` : ''}
                    </div>
                `;
            }
        });

        if (!labelsHtml) {
            alert("Lütfen en az bir etiket miktarı girin.");
            printWindow.close();
            return;
        }

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Barkod Etiketi ${initialList.length === 1 ? `- ${initialList[0].name}` : '(Toplu Yazdırma)'}</title>
                <link href="https://fonts.googleapis.com/css2?family=Libre+Barcode+128&display=swap" rel="stylesheet">
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        margin: 0;
                        padding: 0;
                    }
                    @media print {
                        @page {
                            size: ${settings.size === 'thermal_55x40' ? '55mm 40mm' : 'auto'};
                            margin: 0;
                        }
                        body { margin: 0; padding: 0; }
                        .no-print { display: none; }
                    }
                </style>
            </head>
            <body>
                <div class="no-print" style="margin-bottom: 20px; padding: 15px; background: #f8fafc; border-radius: 8px; font-family: sans-serif;">
                    <strong>📋 Yazdırma Önizlemesi</strong> - ${initialList.length} farklı ürün (${settings.size === 'thermal_55x40' ? '55x40mm' : settings.size})
                    <button onclick="window.print()" style="
                        margin-left: 20px;
                        padding: 8px 16px;
                        background: linear-gradient(135deg, #06C167, #8b5cf6);
                        color: white;
                        border: none;
                        border-radius: 6px;
                        cursor: pointer;
                        font-weight: 600;
                    ">🖨️ Yazdır</button>
                </div>
                <div style="display: flex; flex-wrap: wrap;">
                    ${labelsHtml}
                </div>
                <script>
                    // Auto print after fonts load (simulated delay)
                    setTimeout(() => {
                        // window.print();
                    }, 1000);
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
        onClose();
    };

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <h2 style={styles.title}>Barkod Yazdır</h2>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#94a3b8' }}>&times;</button>
                </div>

                <div style={{ ...styles.formGroup, maxHeight: '250px', overflowY: 'auto', background: '#f8fafc', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px' }}>
                    <label style={{ ...styles.label, marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                        <span>Ürün Listesi ve Miktarlar</span>
                        <span style={{ fontSize: '12px', color: '#06C167' }}>{initialList.length} Ürün</span>
                    </label>
                    {initialList.map(p => (
                        <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px', background: 'white', padding: '8px 12px', borderRadius: '8px', border: '1px solid #f1f5f9' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</div>
                                <div style={{ fontSize: '11px', color: '#64748b' }}>{p.barcode}</div>
                            </div>
                            <input
                                type="number"
                                min="0"
                                value={productQuantities[p.id] || 0}
                                onChange={(e) => setProductQuantities({ ...productQuantities, [p.id]: e.target.value })}
                                style={{ ...styles.input, width: '70px', padding: '6px 10px', height: '36px' }}
                                onClick={e => e.stopPropagation()}
                            />
                        </div>
                    ))}
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Barkod Boyutu</label>
                    <select
                        value={settings.size}
                        onChange={(e) => setSettings({ ...settings, size: e.target.value })}
                        style={styles.select}
                    >
                        <option value="small">Küçük (150px)</option>
                        <option value="medium">Orta (220px)</option>
                        <option value="large">Büyük (300px)</option>
                        <option value="thermal_55x40">Termal Etiket (55x40mm)</option>
                    </select>
                </div>

                {canViewPrices && (
                    <div style={styles.formGroup}>
                        <label style={styles.checkboxLabel}>
                            <input
                                type="checkbox"
                                checked={settings.showPrice}
                                onChange={(e) => setSettings({ ...settings, showPrice: e.target.checked })}
                                style={styles.checkbox}
                            />
                            Etiket üzerinde satış fiyatını göster
                        </label>
                    </div>
                )}

                {/* Preview Info Summary */}
                <div style={{ background: '#f8fafc', padding: '15px', borderRadius: '8px', fontSize: '13px', color: '#64748b' }}>
                    <strong>Toplam Etiket Sayısı:</strong> {Object.values(productQuantities).reduce((a, b) => a + (parseInt(b) || 0), 0)} adet
                </div>

                <div style={styles.modalActions}>
                    <button onClick={onClose} style={{ ...styles.button, ...styles.cancelButton }}>İptal</button>
                    <button onClick={handlePrint} style={{ ...styles.button, ...styles.printButton }}>
                        🖨️ Yazdır
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BarcodePrintModal;
